import type { Ref } from 'vue'
import type { OrderPerson } from '@/composables/useMultipleDiners'

type PaymentMethod = 'cash' | 'card' | 'digital' | 'other'

type NewOrderForm = {
  type: 'Dine-in' | 'Takeaway' | 'Delivery'
  tableId: number | string | null
  customerName: string
  notes: string
  items: Array<{
    menu_item_id: number
    variant_id?: number | null
    quantity: number
    notes?: string
    special_instructions?: string
    unit_price?: number
    extras?: Array<{ name: string; price: number; quantity: number }>
  }>
}

interface MenuSelectorApi {
  resetSelection: () => void
}

interface PaymentSectionApi {
  blurCashInput: () => void
}

interface UsePosNextSaleResetOptions {
  form: Ref<NewOrderForm>
  posMode: Ref<boolean>
  persons: Ref<OrderPerson[]>
  activePersonIndex: Ref<number>
  isPosOnlyMode: Ref<boolean>
  markAsPaid: Ref<boolean>
  selectedPaymentMethod: Ref<PaymentMethod>
  cashReceived: Ref<number>
  resetItemSelection: () => void
  activeTab: Ref<number>
  collapseAllCategories: () => void
  menuSelectorRef: Ref<MenuSelectorApi | null>
  paymentSectionRef: Ref<PaymentSectionApi | null>
}

export function usePosNextSaleReset(options: UsePosNextSaleResetOptions) {
  const resetFormForNextSale = () => {
    options.form.value = {
      type: options.posMode.value ? 'Takeaway' : 'Dine-in',
      tableId: null,
      customerName: '',
      notes: '',
      items: []
    }

    options.persons.value = [
      {
        name: '',
        position: 1,
        items: []
      }
    ]
    options.activePersonIndex.value = 0

    options.markAsPaid.value = options.isPosOnlyMode.value
    options.selectedPaymentMethod.value = 'cash'
    options.cashReceived.value = 0

    options.resetItemSelection()

    options.activeTab.value = options.isPosOnlyMode.value ? 1 : 0

    options.collapseAllCategories()

    options.menuSelectorRef.value?.resetSelection()
    options.paymentSectionRef.value?.blurCashInput()
  }

  return {
    resetFormForNextSale
  }
}
